import { Box, Button, Typography } from '@material-ui/core'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { subscriptionsPromoRoute } from '../../routes/routes'

export const HomeSubscription = ({ isSubscribedBefore }) => {
  const history = useHistory()

  return (
    <Box paddingRight={4}>
      <img
        alt=""
        className="-image"
        src={`${process.env.REACT_APP_BASE_ORDER_URL}/images/home-subscription.png`}
        width="220"
      />
      <Box marginY={2}>
        <Typography variant="h6">Unlimited Delivery</Typography>
        <Typography component="p" gutterBottom variant="body1">
          Say goodbye to delivery fees with Unlimited Delivery.{' '}
          {!isSubscribedBefore
            ? 'Get your first month free and cancel anytime.'
            : 'Cancel anytime.'}
        </Typography>
      </Box>
      <Button
        color="primary"
        onClick={() => history.push(subscriptionsPromoRoute.path)}
        variant="contained"
      >
        {isSubscribedBefore ? 'Subscribe' : 'Try free for 30 days'}
      </Button>
    </Box>
  )
}

export default HomeSubscription
